export default __webpack_public_path__ + "static/media/camera.a696be93.webp";